'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactChartjs = require('react-chartjs');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _TargetDateSeriesDoughnutChart = require('./TargetDateSeriesDoughnutChart.css');

var _TargetDateSeriesDoughnutChart2 = _interopRequireDefault(_TargetDateSeriesDoughnutChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * Displays the doughnut chart and taglines for the selected issue.
 *
 *
 * Depending on which of the target date series is selected; as well as which
 * of the six allowed issues is selected; it will show different:
 *
 * - chart
 * - list of sentences describing exposure for different risk sectors
 *
 * (GEF does not have a doughnut chart.)
 *
 */
var TargetDateSeriesDoughnutChart = (_dec = (0, _reactCssModules2.default)(_TargetDateSeriesDoughnutChart2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeriesDoughnutChart, _Component);

  function TargetDateSeriesDoughnutChart(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeriesDoughnutChart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TargetDateSeriesDoughnutChart.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeriesDoughnutChart)).call(this, props));

    var iyvCode = props.iyvCode,
        targetDateSeries = props.targetDateSeries;


    var chartData = null;
    var taglines = null;
    switch (iyvCode) {
      case 'fff':
        chartData = [{
          value: targetDateSeries.ff_all_weight * 100.0,
          label: 'Fossil fuel companies',
          color: '#333333'
        }, {
          value: (1 - targetDateSeries.ff_all_weight) * 100.0,
          label: 'Other',
          color: '#CCCCCC'
        }];
        taglines = [_react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            _format2.default.perc(targetDateSeries.ff_all_weight)
          ),
          ' invested in fossil fuels.'
        )];
        break;

      case 'dff':
        chartData = [{
          value: targetDateSeries.df_all_weight * 100.0,
          label: 'Deforestation-risk screens',
          color: '#333333'
        }, {
          value: (1 - targetDateSeries.df_all_weight) * 100.0,
          label: 'Other',
          color: '#CCCCCC'
        }];
        taglines = [_react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            _format2.default.perc(targetDateSeries.df_p_weight)
          ),
          ' invested in deforestation-risk agribusiness.'
        ), _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            _format2.default.perc(targetDateSeries.df_f_weight)
          ),
          ' invested in deforestation-risk finance.'
        ), _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            _format2.default.perc(targetDateSeries.df_c_weight)
          ),
          ' invested in deforestation-risk consumer brands.'
        )];
        break;

      case 'ffb':
        chartData = [{
          value: targetDateSeries.fossil_bank_weight * 100.0,
          label: 'Fossil fuel lenders & underwriters',
          color: '#333333'
        }, {
          value: (1 - targetDateSeries.fossil_bank_weight) * 100.0,
          label: 'Other',
          color: '#CCCCCC'
        }];
        taglines = [_react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            _format2.default.perc(targetDateSeries.fossil_bank_weight)
          ),
          ' invested in fossil fuel lenders & underwriters.'
        )];
        break;

      case 'ffi':
        chartData = [{
          value: targetDateSeries.fossil_insure_weight * 100.0,
          label: 'Fossil fuel insurers',
          color: '#333333'
        }, {
          value: (1 - targetDateSeries.fossil_insure_weight) * 100.0,
          label: 'Other',
          color: '#CCCCCC'
        }];
        taglines = [_react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            _format2.default.perc(targetDateSeries.fossil_insure_weight)
          ),
          ' invested in fossil fuel insurers.'
        )];
        break;

      // case 'gef':
      //   break

      case 'gff':
        chartData = [{
          value: targetDateSeries.wff_gun_manufacturers_weight * 100.0,
          label: 'Gun manufacturers',
          color: '#333333'
        }, {
          value: targetDateSeries.wff_gun_retailers_weight * 100.0,
          label: 'Gun retailers',
          color: '#333333'
        }, {
          value: (1 - targetDateSeries.wff_civ_weight) * 100.0,
          label: 'Other',
          color: '#CCCCCC'
        }];
        taglines = [_react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            _format2.default.perc(targetDateSeries.wff_gun_manufacturers_weight)
          ),
          ' invested in gun manufacturers.'
        ), _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            _format2.default.perc(targetDateSeries.wff_gun_retailers_weight)
          ),
          ' invested in gun retailers.'
        )];
        break;

      case 'pff':
        chartData = [{
          value: targetDateSeries.pff_all_weight * 100.0,
          label: 'Prison industrial complex screen',
          color: '#333333'
        }, {
          value: (1 - targetDateSeries.pff_all_weight) * 100.0,
          label: 'Other',
          color: '#CCCCCC'
        }];
        taglines = [
        // (
        // <span>
        //   <b>{format.perc(targetDateSeries.pff_extreme_weight)}</b> invested
        //   in private prison operators screen.
        // </span>
        // ),
        // (
        // <span>
        //   <b>{format.perc(targetDateSeries.pff_high_weight)}</b> invested in
        //   higher-risk prison industrial complex screen.
        // </span>
        // ),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            _format2.default.perc(targetDateSeries.pff_all_weight)
          ),
          ' invested in companies involved in the prison industrial complex.'
        )];
        break;

      case 'wff':
        chartData = [{
          value: targetDateSeries.wff_mil_weight * 100.0,
          label: 'Military weapons screen',
          color: '#333333'
        }, {
          value: (1 - targetDateSeries.wff_mil_weight) * 100.0,
          label: 'Other',
          color: '#CCCCCC'
        }];
        taglines = [
        // (
        // <span>
        //   <b>
        //     {format.perc(targetDateSeries.wff_nuclear_weapons_weight)}
        //   </b> invested in companies involved with nuclear weapons.
        // </span>
        // ),
        // (
        // <span>
        //   <b>
        //     {format.perc(targetDateSeries.wff_cluster_munitions_weight)}
        //   </b> invested in companies involved with controversial weapons.
        // </span>
        // ),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            _format2.default.perc(targetDateSeries.wff_major_military_contractors_weight)
          ),
          ' invested in military contractors.'
        )];
        break;

      case 'tff':
        chartData = [{
          value: targetDateSeries.t_weight * 100.0,
          label: 'Tobacco producers companies',
          color: '#333333'
        }, {
          value: targetDateSeries.t_m_weight * 100.0,
          label: 'Tobacco-promoting entertainment companies',
          color: '#333333'
        }, {
          value: (1 - targetDateSeries.t_all_weight) * 100.0,
          label: 'Other',
          color: '#CCCCCC'
        }];
        taglines = [_react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            _format2.default.perc(targetDateSeries.t_weight)
          ),
          ' invested in tobacco producers.'
        ), _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            _format2.default.perc(targetDateSeries.t_m_weight)
          ),
          ' invested in tobacco-promoting entertainment companies.'
        )];
        break;
    }

    _this.state = {
      chartData: chartData,
      taglines: taglines
    };
    return _this;
  }

  //


  (0, _createClass3.default)(TargetDateSeriesDoughnutChart, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          chartData = _state.chartData,
          taglines = _state.taglines;

      if (!chartData || !taglines) {
        return null;
      }

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'doughnut-flex' },
        _react2.default.createElement(
          'div',
          { styleName: 'doughnut-flex-doughnut' },
          _react2.default.createElement(_reactChartjs.Doughnut, {
            data: chartData,
            options: _config2.default.chartOptions,
            width: '100',
            height: '100'
          })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'doughnut-flex-content' },
          _react2.default.createElement(
            'div',
            null,
            taglines.map(function (e, i) {
              return _react2.default.createElement(
                'div',
                {
                  key: 'doughnut-tagline-' + i,
                  styleName: 'doughnut-flex-content-text'
                },
                e
              );
            })
          )
        )
      );
    }
  }]);
  return TargetDateSeriesDoughnutChart;
}(_react.Component), _class2.propTypes = {
  // three letters, fff/dff/gef/gff/pff/wff/tff
  iyvCode: _react.PropTypes.string.isRequired,
  // the target date series object
  targetDateSeries: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = TargetDateSeriesDoughnutChart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesDoughnutChart/TargetDateSeriesDoughnutChart.js
// module id = 1446
// module chunks = 0